export const TRIGGER_RANDOM_ANIMATION = 'TRIGGER_RANDOM_ANIMATION';
export const animationRandomizerThreshold = 20;


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/store/animation/constants.ts